import { render } from "./ServicesPage.vue?vue&type=template&id=a4731566&ts=true"
import script from "./ServicesPage.vue?vue&type=script&lang=ts"
export * from "./ServicesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__